import { IUsuarioLogado } from "@/interfaces/IUsuarioLogado";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface IUsuarioLogadoState {
  user: IUsuarioLogado;
}

const initialState: IUsuarioLogadoState = {
  user: {
    pessoaId: 0,
    nome: "",
    cpfCnpj: "",
    perfil: { id: 0, nome: "", ativo: false, permissoes: [] },
  },
};

const usuarioLogadoSlice = createSlice({
  name: "USUARIO_LOGADO",
  initialState,
  reducers: {
    add: (state, action: PayloadAction<{ user: IUsuarioLogado }>) => {
      const { user } = action.payload;
      state.user = user;
    },
    remove: (state) => {
      state.user = initialState.user;
    },
  },
});

export default usuarioLogadoSlice.reducer;

export const getUser = (state: RootState) => {
  return state.usuarioLogado.user;
};
